































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AssignEmployee from "./assign-employee.vue";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import Ref from "../../../store/entities/ref";
import User from "@/store/entities/user";
import SoRequestInfo from "./view-pick-list-sor.vue";
import PickListInfo from "../../../store/entities/pick-list";

class PagePickListRequest extends PageRequest {
  keyword: string;
  from: Date;
  to: Date;
  type: string;
  refType: string;
  status: string;
  assigeedEmployeeId: number;
}

@Component({
  components: { AssignEmployee, "sorequest-info": SoRequestInfo },
})
export default class PickList extends AbpBase {
  //filters
  pagerequest: PagePickListRequest = new PagePickListRequest();
  creationTime: Date[] = [];
  assignPickListModalShow: boolean = false;
  isAllowedToAssign: boolean = false;
  plIds: Array<number> = new Array<number>();
  plTypes: Array<Ref> = new Array<Ref>();
  refStatuses: Array<Ref> = new Array<Ref>();
  employeesFilter: Array<User> = new Array<User>();
  objectTypes = [];
  soRequestInfoModalShow = false;
  pickListInfo = new PickListInfo();
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get list() {
    var re = this.$store.state.picklist.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      if (!item.canAssign) {
        item._disabled = true;
      }
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  create() {
    this.$root.$router.push({ name: "create-picklist" });
  }
  async getObjectTypes() {
    await this.$store
      .dispatch({
        type: "ref/getRefTypesForSelect",
      })
      .then(() => {
        let re = this.$store.state.ref.refTypesForSelect;
        if (re.length > 0) {
          re = _.filter(re, (v) =>
            _.includes(AppConsts.refTypeForPickWave, v.code)
          );
          re.forEach((element) => {
            element.description = this.L(
              `${AppConsts.prefixConsts.ref}${element.code}`
            );
          });
          re.unshift({
            code: `${AppConsts.prefixConsts.ref}${AppConsts.All}`,
            description: this.L(AppConsts.All),
          });
          this.$set(this.pagerequest, "refType", re[0].code);
        }

        this.objectTypes = re;
      });
  }

  getPlTypes(re) {
    if (re.length > 0) {
      re.forEach((element) => {
        element.description = this.L(
          `${AppConsts.prefixConsts.plType}${element.code}`
        );
      });
      re.unshift({
        code: `${AppConsts.prefixConsts.plType}${AppConsts.All}`,
        description: this.L(AppConsts.All),
      });
      this.$set(this.pagerequest, "type", re[0].code);
      this.plTypes = re;
    }
  }

  getRefStatuses(re) {
    if (re.length > 0) {
      re.forEach((element) => {
        element.description = this.L(
          `${AppConsts.prefixConsts.plStatus}${element.code}`
        );
      });
      re.unshift({
        code: `${AppConsts.prefixConsts.plStatus}${AppConsts.All}`,
        description: this.L(AppConsts.All),
      });
      this.$set(this.pagerequest, "status", re[0].code);
      this.refStatuses = re;
    }
  }

  getEmployeesFilter(re) {
    re.forEach((element) => {
      element.formatName = `${element.userName} - ${element.name}`;
    });
    re.unshift({ id: -1, formatName: this.L(AppConsts.All) });
    this.$set(this.pagerequest, "assigeedEmployeeId", re[0].id);
    this.employeesFilter = re;
  }

  get loading() {
    return this.$store.state.picklist.loading;
  }

  assign() {
    this.plIds = new Array<number>();
    this.list.forEach((element) => {
      if (element.isSelected) {
        this.plIds.push(element.id);
      }
    });
    this.$store.commit("picklist/selectEmployee", this.plIds);
    this.assignPickListModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("picklist/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("picklist/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.isAllowedToAssign = false;
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    if (this.creationTime.length > 0) {
      this.pagerequest.from = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.to = this.creationTime[1];
    }
    this.$store
      .dispatch({
        type: "picklist/search",
        data: this.pagerequest,
      })
      .catch((error) => {
        this.$store.commit("picklist/setIsLoading", false);
      });
  }
  get pageSize() {
    return this.$store.state.picklist.pageSize;
  }
  get totalCount() {
    return this.$store.state.picklist.totalCount;
  }
  get currentPage() {
    return this.$store.state.picklist.currentPage;
  }
  columns = [
    {
      title: this.L("Order"),
      width: 60,
      fixed: "left",
      key: "orderNo",
    },
    {
      title: this.L("Code"),
      width: 200,
      fixed: "left",
      key: "code",
    },
    {
      title: this.L("Type"),
      width: 280,
      key: "type",
      render: (h: any, params: any) => {
        return h(
          "span",
          this.L(`${AppConsts.prefixConsts.plType}${params.row.type}`)
        );
      },
    },
    {
      title: this.L("RefType"),
      width: 150,
      key: "refType",
      render: (h: any, params: any) => {
        return h(
          "span",
          this.L(`${AppConsts.prefixConsts.ref}${params.row.refType}`)
        );
      },
    },
    {
      title: this.L("Status"),
      width: 120,
      key: "status",
      render: (h: any, params: any) => {
        return h(
          "span",
          this.L(`${AppConsts.prefixConsts.plStatus}${params.row.status}`)
        );
      },
    },
    {
      title: this.L("NumOfObject"),
      width: 100,
      slot: "numOfObject",
      align: "right",
    },
    {
      title: this.L("NumOfItem"),
      width: 100,
      key: "numOfItem",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.numOfItem));
      },
    },
    {
      title: this.L("Employee"),
      width: 200,
      key: "employeeName",
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 200,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: this.L("CreatorUserName"),
      key: "creatorUserName",
      width: 200,
    },
    {
      type: "selection",
      width: 50,
      fixed: "right",
    },
    {
      title: this.L("Action"),
      width: 90,
      fixed: "right",
      align: "center",
      slot: "actionPl",
    },
  ];

  onSelect(selection, row) {
    this.$emit("on-select", selection, row);
  }
  onSelectCancel(selection, row) {
    this.$emit("on-select-cancel", selection, row);
  }
  onSelectAll(selection) {
    this.$emit("on-select-all", selection);
  }
  onSelectionChange(selection) {
    this.$emit("on-selection-change", selection);
    _.forEach(this.list, (o) => {
      var itemSelected = _.find(selection, function(x) {
        return x.id === o.id;
      });
      if (itemSelected) {
        o.isSelected = true;
      } else {
        o.isSelected = false;
      }
    });

    var allowedToAssign = false;
    _.forEach(this.list, (item) => {
      if (item.isSelected) {
        allowedToAssign = true;
        return;
      }
    });

    this.isAllowedToAssign = allowedToAssign;
  }

  changeSelect(index) {
    if (!this.list[index].isSelected) this.list[index].isSelected = true;
    else this.list[index].isSelected = false;

    var allowedToAssign = false;
    _.forEach(this.list, (item) => {
      if (item.isSelected) {
        allowedToAssign = true;
        return;
      }
    });

    this.isAllowedToAssign = allowedToAssign;
  }
  showSoRequests(row: any) {
    this.pickListInfo = row;
    this.soRequestInfoModalShow = true;
  }
  closeSoRequestInfoModal() {
    this.soRequestInfoModalShow = false;
  }
  async created() {
    await this.getObjectTypes();
    await this.$store
      .dispatch({
        type: "ref/getRefsForSelect",
        param: {
          tableName: AppConsts.tableRef.tablePl.name,
          columnName: AppConsts.tableRef.tablePl.column.type,
        },
      })
      .then((res) => {
        this.getPlTypes(res);
      });
    await this.$store
      .dispatch({
        type: "ref/getRefsForSelect",
        param: {
          tableName: AppConsts.tableRef.tablePl.name,
          columnName: AppConsts.tableRef.tablePl.column.status,
        },
      })
      .then((res) => {
        this.getRefStatuses(res);
      });
    await this.$store
      .dispatch({
        type: "user/getEmployeesInWarehouse",
      })
      .then(() => {
        this.getEmployeesFilter(this.$store.state.user.employees);
      });
    var defaultDate = new Date();
    this.creationTime = [defaultDate, defaultDate];
  }
}
